import { Typography } from "antd"
import './../../css/style.css';

function Successful() {

    const { Title, Text } = Typography;

    return (
        <>
            <Title className="text">SOLICITUD REGISTRADA</Title>
            <Text className="text">Solicitud registrada con éxito.</Text>
            <Text className="text">Ud podrá presentarse en la sucursal seleccionada para retirar su tarjeta de débito y firmar la documentación</Text>
            <Text className="text">necesaria, debiendo presentar la siguiente documentación:</Text>            
            <Text className="text">-Cédula de Identidad.</Text>
            <Text className="text">-Constancia de Domicilio.</Text>
            <Text className="text">-Justificación de Ingresos.</Text>
            <Text className="text">Solicitud registrada con éxito.</Text>
            <Text className="text">Dirijase a la sucursal seleccionada dentro de las siguientes 72 horas hábiles para completar el tramite.</Text>
        </>
    )
}

export { Successful }